<template lang="pug">
v-dialog(v-model="modal", width="80%", persistent)
  v-card
    v-card-title
      .headline.text-center(style="word-break: normal", v-text="text2")
    v-card-actions
      v-spacer
      v-btn(text, @click="modal = false") cancel
      v-btn(text, color="primary", @click="notify('approve')") approved
      v-btn(text, color="primary", @click="notify('refuse')") refused
      v-btn(text, color="primary", @click="notify('reject')") rejected
</template>

<script>
export default {
  name: "OverviewLicenseModal",

  props: {
    value: {
      type: Boolean,
      required: true,
    },

    caseID: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    text1:
      "Please confirm whether your sponsorship licence " +
      "was approved, refused or rejected by the Home Office?",
    text2:
      "Please let us know the decision from the Home Office " +
      "about your Sponsor licence application.",
  }),

  methods: {
    notify(status) {
      this.axios
        .get(`/employer/case/${this.caseID}/sponsorship/${status}`)
        .then(() => {
          this.$emit("success");
          this.modal = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },

  computed: {
    modal: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
};
</script>